"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const hooks_1 = require("../../../ui/hooks");
const utils_1 = require("../../../ui/utils");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const Image = (props) => {
    const storage = (0, hooks_1.useAttachmentClient)();
    const [imageDataUrl, setImageDataUrl] = react_1.default.useState();
    const [loading, setLoading] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        const timeoutHandle = setTimeout(() => setLoading(true), 500);
        (0, utils_1.getImageDataUrl)(storage, props.entity, props.entityId, props.attachmentKey, props.version)
            .then(setImageDataUrl)
            .catch(SnackbarHelper_1.handleErrorSnackbar)
            .finally(() => {
            setLoading(false);
            clearTimeout(timeoutHandle);
        });
        return () => clearTimeout(timeoutHandle);
    }, [props, storage]);
    if (loading) {
        return react_1.default.createElement(material_1.CircularProgress, null);
    }
    if (!imageDataUrl) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(material_1.Box, { component: 'img', sx: props.sx, src: imageDataUrl, "data-test": props['data-test'], alt: props.alt });
};
exports.Image = Image;
